export default __webpack_public_path__ + "static/media/proj2.8a11a40c.png";